/* eslint-disable consistent-return */
/* eslint-ignore */
// @ts-ignore
// @ts-nocheck
import { toast } from 'react-toastify';
import api from 'services/api';
import { cleanCPFAndCNPJ } from 'utils/functions';
import { getAccessToken } from './accessTokenServices';

export const getCustomerAddress = async (document, customerCode, userId) => {
  try {
    const access_token = await getAccessToken();

    const responseAddress = await api.get(
      `industrial/customer/v1/customers?document=${document}&code=${customerCode}&type=EMP&_expand=CONTACT&not-in-user-id=${userId}`,
      {
        headers: {
          access_token,
          client_id: process.env.REACT_APP_CLIENT_ID,
        },
      }
    );

    if (responseAddress.status === 200) {
      return responseAddress.data;
    }

    throw new Error('Ocorreu um erro interno na aplicação');
  } catch (error) {
    if (error.response.status === 422) {
      return toast.error(error.response.data.message);
    }
    return toast.error(error.message);
  }
};

export const postCustomer = async (
  userId,
  document,
  customerCode,
  siteId,
  termsAccepted
) => {
  const access_token = await getAccessToken();
  const header = {
    'Content-Type': 'application/json',
    access_token,
    client_id: process.env.REACT_APP_CLIENT_ID,
  };

  console.log({ header });
  const parameters = {
    method: 'POST',
    headers: header,
  };

  const body = {
    customerCode,
    document,
    siteId,
    termsAccepted,
  };

  try {
    const responseCustomer = await api.post(
      `industrial/customer/v1/users/${userId}/customers`,
      body,
      parameters
    );

    if (responseCustomer.status === 201) {
      return true;
    }

    return false;
  } catch (error) {
    toast.error(error.response.data.message);
  }
};

export const postUserCustomer = async (
  document,
  customerCode,
  siteId,
  termsAccepted
) => {
  const access_token = await getAccessToken();

  const header = {
    'Content-Type': 'application/json',
    access_token,
  };

  const parameters = {
    method: 'POST',
    headers: header,
  };

  const body = {
    customerCode,
    document,
    siteId,
    termsAccepted,
  };

  let userId = null;

  try {
    const responseUsers = await api.post(
      'industrial/customer/v1/users',
      body,
      parameters
    );

    if (responseUsers.status === 201) {
      const hateoas = responseUsers.headers.location;
      userId = hateoas.split('/').pop();
    }

    return userId;
  } catch (error) {
    toast.error(error.message);
  }
};

export const postContact = async (
  contact,
  contactType,
  document,
  customerCode,
  userId,
  siteId,
  name,
  lastName
) => {
  const access_token = await getAccessToken();

  const header = {
    'Content-Type': 'application/json',
    access_token,
  };

  const parameters = {
    method: 'POST',
    headers: header,
  };

  const body = {
    name,
    lastName,
    contact,
    contactType,
    customerCode,
    document: cleanCPFAndCNPJ(document),
    siteId,
  };

  let contactId = null;

  try {
    const responseContacts = await api.post(
      `industrial/customer/v1/users/${userId}/contacts`,
      body,
      parameters
    );

    if (responseContacts.status === 201) {
      const hateoas = responseContacts.headers.location;
      contactId = hateoas.split('/').pop();
    }

    return contactId;
  } catch (error) {
    toast.error(error.response.data.message);
  }
};

export const createNewContactUser = async (siteId, userId, body) => {
  const access_token = await getAccessToken();

  const header = {
    'Content-Type': 'application/json',
    access_token,
  };

  const parameters = {
    method: 'POST',
    headers: header,
  };

  try {
    const responseContacts = await api.post(
      `industrial/customer/v1/users/${userId}/contacts`,
      body,
      parameters
    );

    const contactId = responseContacts.headers.location.split('/contacts/')[1];

    if (responseContacts.status === 201) {
      return contactId;
    }
  } catch (error) {
    if (error.response.status === 404) {
      toast.error(
        'Ocorreu um erro ao cadastrar seu contato, tente novamente mais tarde!'
      );
    } else {
      toast.error(error.response.data.message);
    }
    return '';
  }
};

export const updateContactUser = async (userId, contactId, body) => {
  const access_token = await getAccessToken();

  const header = {
    'Content-Type': 'application/json',
    access_token,
  };

  const parameters = {
    method: 'PATCH',
    headers: header,
  };

  try {
    const responseContacts = await api.patch(
      `industrial/customer/v1/users/${userId}/contacts/${contactId}`,
      body,
      parameters
    );

    if (responseContacts.status === 204) {
      return true;
    }
  } catch (error) {
    toast.error(error.response.data.message);
  }
};

export const postUserPassword = async (
  contactId,
  password,
  passwordConfirmation,
  userId
) => {
  const access_token = await getAccessToken();

  const header = {
    'Content-Type': 'application/json',
    access_token,
  };

  const parameters = {
    method: 'POST',
    headers: header,
  };

  const body = {
    contactId,
    password,
    passwordConfirmation,
  };

  try {
    const responseUserPassword = await api.post(
      `industrial/customer/v1/users/${userId}/passwords`,
      body,
      parameters
    );

    const tokenMFA = responseUserPassword.headers['x-mfa-hash'];

    if (tokenMFA) {
      localStorage.setItem('@UltragazEmpresarial:X-Mfa-Hash', tokenMFA);
    }

    if (responseUserPassword.status === 201) {
      return true;
    }
  } catch (error) {
    if (error.response.data.code === '422.007') {
      toast.error(error.response.data.message);
    } else {
      toast.error('Ocorreu um erro ao cadastrar seu contato, tente novamente!');
    }
  }
};

export const postUserToken = async (
  contactId,
  customerCode,
  document,
  userId,
  email
) => {
  const access_token = await getAccessToken();

  const header = {
    'Content-Type': 'application/json',
    access_token,
  };

  const parameters = {
    method: 'POST',
    headers: header,
  };

  const body = {
    tokenType: 'REGISTER',
    url: `${process.env.REACT_APP_REGISTER_URL_CONFIRMATION}/novo-primeiro-acesso-granel/?email=${email}`,
    contactId,
    customerCode,
    document: cleanCPFAndCNPJ(document),
  };

  try {
    const responseRegister = await api.post(
      `industrial/customer/v1/users/${userId}/tokens`,
      body,
      parameters
    );

    if (responseRegister.status === 202) {
      return true;
    }

    throw new Error('Ocorreu um erro interno, tente novamente');
  } catch (error) {
    toast.error(error.response.data.message);
  }
};

export const postConfirmEmail = async (userId, token) => {
  const access_token = await getAccessToken();

  const header = {
    'Content-Type': 'application/json',
    access_token,
  };

  const parameters = {
    method: 'POST',
    headers: header,
  };

  const body = {
    token,
  };

  try {
    const responseValidateToken = await api.post(
      `industrial/customer/v1/users/${userId}/validations`,
      body,
      parameters
    );

    if (responseValidateToken.status === 202) {
      return true;
    }
  } catch (error) {
    return false;
  }
};
